import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const ModalBody = styled(Modal.Body)`
    h3 {
        font-family: ${({ theme }) => theme['font-bold']};
        color: ${({ theme }) => theme['gray-1000']};
        margin: 0 20px;
    }

    hr {
        margin: 20px;
        border-color: ${({ theme }) => theme['gray-1000']};
    }

    table {
        margin: 20px;
        width: calc(100% -40px);

        &,
        tr,
        td,
        th {
            color: ${({ theme }) => theme['gray-1000']};
            border: 1px solid ${({ theme }) => theme['gray-1000']};
        }

        th,
        td {
            padding: 5px;
        }

        th {
            text-align: center;
        }

        thead > tr > th {
            font-family: ${({ theme }) => theme['font-bold']};
            font-size: 16px;
        }
    }
`

export const BarrierIcons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin: 20px;
    font-family: ${({ theme }) => theme['font-regular']};
    font-size: 16px;
    color: ${({ theme }) => theme['gray-1000']};

    div {
        display: flex;
        justify-content: start;
        align-items: center;
        gap: 15px;
    }

    svg {
        path {
            fill: ${({ theme }) => theme['gray-1000']};
        }
    }
`

export const ModalCloseButton = styled.button`
    position: absolute;
    height: 36px;
    width: 36px;
    top: calc(50%);
    transform: translateY(-50%);
    right: 4px;
    border: none;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    font-size: 16px;

    :hover {
        background: ${({ theme }) => theme['gray-100']};
    }
`
